import { NavLink } from "react-router-dom";
import { useApp } from "@/store/AppStore";
import { navForRole } from "@/components/layout/navItems";
import BrandLogo from "@/components/layout/BrandLogo";

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

const Sidebar = ({ open, onClose }: SidebarProps) => {
  const { data } = useApp();
  const items = navForRole(data.role);

  return (
    <>
      {open && (
        <div
          className="fixed inset-0 z-40 bg-background-50/70 backdrop-blur-sm lg:hidden"
          onClick={onClose}
          aria-hidden="true"
        />
      )}
      <aside
        className={`fixed top-0 left-0 z-50 h-full w-[262px] glass-panel-strong flex flex-col transition-transform duration-300 lg:translate-x-0 ${
          open ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="px-5 h-[76px] flex items-center justify-between border-b border-accent-500/15">
          <BrandLogo />
          <button
            onClick={onClose}
            className="lg:hidden w-8 h-8 flex items-center justify-center rounded-md text-foreground-600 hover:text-foreground-950 hover:bg-background-200/60 cursor-pointer"
            aria-label="Cerrar menú"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
          <p className="px-3 pb-2 text-[11px] font-semibold uppercase tracking-wider text-foreground-500">
            {data.role === "admin" ? "Módulos Administrador" : "Portal Asesor"}
          </p>
          {items.map((item) => (
            <NavLink
              key={item.key}
              to={item.path}
              end={item.path === "/admin" || item.path === "/asesor"}
              onClick={onClose}
              className={({ isActive }) =>
                `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors cursor-pointer ${
                  isActive
                    ? "bg-primary-500/25 text-foreground-950 border border-accent-500/30"
                    : "text-foreground-600 hover:bg-background-200/50 hover:text-foreground-900 border border-transparent"
                }`
              }
            >
              <span className="w-6 h-6 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-lg`} />
              </span>
              <span className="flex-1 whitespace-nowrap">{item.label}</span>
              {item.phase && (
                <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full bg-secondary-500/25 text-secondary-200 whitespace-nowrap">
                  F{item.phase}
                </span>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-accent-500/15">
          <div className="rounded-lg bg-background-200/50 border border-accent-500/15 p-3">
            <div className="flex items-center gap-2 text-accent-300 mb-1">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shield-user-line" />
              </span>
              <span className="text-xs font-semibold">
                {data.role === "admin" ? "Juanka · Gerencia" : "Portal Distribuidor"}
              </span>
            </div>
            <p className="text-[11px] text-foreground-500 leading-snug">
              Conectado a la base de datos. Tus datos se guardan y protegen por usuario.
            </p>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;